import { Divider } from '@mui/material'
import TopMenu from './Tree/TopMenu'
import Structure from './Structure'

export function Tree() {
  return (
    <>
      <TopMenu />
      <Divider sx={{ my: 3 }} />
      <Structure />
    </>
  )
}

export default Tree
